import React from 'react';
import {Grid} from '@mui/material';
import SampleAssetDisplay from '@contentlab/components/sample-asset-display';
import {scrollbarMixins} from '@contentlab/styles/mixins';
import sampleAssets from './sampleAssets';

function SampleAssetsModal({
  selectedAsset,
  setSelectedAsset,
}: {
  selectedAsset: number | null;
  setSelectedAsset: (asset: number | null) => void;
}) {
  return (
    <Grid
      container
      spacing="16px"
      maxHeight="405px"
      overflow="auto"
      sx={{
        ...scrollbarMixins.overrideScrollbarHidden(),
        paddingBottom: '12px',
        marginRight: '-8px',
      }}
    >
      {sampleAssets.map((asset) => (
        <Grid item key={asset.id}>
          <SampleAssetDisplay
            isSelected={asset.id === selectedAsset}
            setSelectedAsset={() => setSelectedAsset(asset.id)}
            asset={asset}
          />
        </Grid>
      ))}
    </Grid>
  );
}

export default SampleAssetsModal;
